import { useState } from "react";
import { Helmet } from "react-helmet";
import { toastAlert } from "../../config/toastAlert";
import { algotradepageform } from "../../config/apiCall";
import httpService from "../../config/httpCall";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Cex() {
  const NewFormValue = {
    username: "",
    useremail: "",
    usermessage: "",
  };
  const validate = async () => {
    try {
      var error = {};

      if (newValue.username == "") {
        setusernameErr(true);
        setvalidateErr(true);
        error.username = "Must Enter the field";
      } else {
        setusernameErr(false);
        setvalidateErr(false);
      }
      if (newValue.usermessage == "") {
        setusermessageErr(true);
        setvalidateErr(true);

        error.usermessage = "Must Enter the field";
      } else {
        setusermessageErr(false);
        setvalidateErr(false);
      }

      if (newValue.useremail == "") {
        setuseremailErr(true);
        setvalidateErr(true);

        error.useremail = "Must Enter the field ";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(newValue.useremail)
      ) {
        setuseremailErr(true);
        setvalidateErr(true);

        error.useremail = "Invalid Mail";
      } else {
        setuseremailErr(false);
        setvalidateErr(false);
      }

      setvalidationErrors(error);
    } catch (error) {}
  };
  const handleNewFormChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      let formData = { ...newValue, ...{ [name]: value } };
      setnewValue(formData);
    } catch (error) {}
  };
  const [newValue, setnewValue] = useState(NewFormValue);
  const { username, useremail, usermessage } = newValue;
  const [validateErr, setvalidateErr] = useState("");
  const [validationErrors, setvalidationErrors] = useState("");
  const [usernameErr, setusernameErr] = useState(false);
  const [useremailErr, setuseremailErr] = useState(false);
  const [usermessageErr, setusermessageErr] = useState(false);
  const sendQuestion = async () => {
    try {
      validate(NewFormValue);
      if (useremail != "" && usermessage != "" && username != "") {
        if (validateErr == false) {
          var obj = {
            username: username,
            usermessage: usermessage,
            useremail: useremail,
          };
          var obj = {
            apiUrl: httpService.algotradepageform,
            payload: obj,
          };
          var messageSent = await algotradepageform(obj);
          if (messageSent) {
            NewFormValue.useremail = "";
            NewFormValue.username = "";
            NewFormValue.usermessage = "";
            toastAlert("success", messageSent.Message);
          } else {
            useremail = "";
            username = "";
            usermessage = "";
            toastAlert("error", messageSent.Message);
          }
        } else {
        }
      } else {
        validate(NewFormValue);
      }
    } catch (err) {}
  };
  return (
    <div className="defi_txt_content">
      <header className="newpage nft_new_page fixed_header p-0">
        {/* <Header /> */}
        <NewHead />
      </header>
      <div className="paddin_immner">
        <main className="carer_page">
          <span>
            <Helmet>
              <title>
                Defi Development Company | Defi Development Services
              </title>
              <link
                rel="canonical"
                href="https://beleaftechnologies.com/defi-development-company"
              />
              <meta
                name="title"
                content="Defi Development Company | Defi Development Services "
              />
              <meta
                name="description"
                content="Beleaf Technology- DeFi Development Company, provides world-class DeFi Development Services to create DeFi Protocols Like Uniswap,Compound, Yearn Finance and more"
              />
              <meta
                name="keywords"
                content="defi development company, defi development services, defi protocols development, defi projects development companyDecentralized Finance Solutions, Decentralized Finance Solutions Provider, Decentralized Finance Development, DeFi Dapp Development, DeFi Smart Contract Development, DeFi Dapp, defi pulse,defi crypto, defi finance, defi lending,decentralized finance projects, decentralized finance regulations, DeFi"
              />
              <meta
                property="og:title"
                content=" Defi Development Company | Defi Development Services "
              />
              <meta property="og:site_name" content="Beleaf Technologies" />
              <meta
                property="og:url"
                content="https://beleaftechnologies.com/defi-development-company"
              />
              <meta
                property="og:description"
                content="Beleaf Technology- DeFi Development Company, provides world-class DeFi Development Services to create DeFi Protocols Like Uniswap,Compound, Yearn Finance and more"
              />
              <meta property="og:type" content="website" />

              <meta name="twitter:card" content="summary" />
              <meta name="twitter:site" content="@BeleafTech" />
              <meta
                name="twitter:title"
                content="Defi Development Company | Defi Development Services "
              />
              <meta
                name="twitter:description"
                content="Beleaf Technology- DeFi Development Company, provides world-class DeFi Development Services to create DeFi Protocols Like Uniswap,Compound, Yearn Finance and more"
              />

              <meta name="twitter:image:alt" content="Beleaf Technologies" />
            </Helmet>

            <section className="defi-hero-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="defi-hero-content">
                      <h1>
                        <span>DeFi</span> Development Company
                      </h1>
                      <p>
                        We specialize in creating decentralised finance (DeFi)
                        solutions that allow individuals and businesses to
                        access financial services in a secure and transparent
                        manner. Our team of experts combines advanced 
                        technology with industry experience to deliver
                        innovative DeFi solutions developed to your needs.
                      </p>

                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Contact Us"
                        className="defi-button"
                      >
                        Free Demo
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="defi-hero-banner">
                      <img
                        src={require("../../image/new/DEFI/defi-hero-banner.webp")}
                        alt="Defi Development Company"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="what-is-defi-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="what-defi-banner">
                      <img
                        src={require("../../image/new/DEFI/defi-what-is-banner.webp")}
                        alt="Defi Development Company"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="what-defi-content">
                      <h2>
                        <span>What is</span> <br />
                        DeFi Development?
                      </h2>
                      <p>
                        <img
                          src={require("../../image/new/DEFI/arrow.png")}
                          alt="Defi Development Company"
                        />
                        <span>
                          DeFi development refers to creating decentralized
                          financial applications using blockchain technology.
                        </span>
                      </p>
                      <p>
                        <img
                          src={require("../../image/new/DEFI/arrow.png")}
                          alt="Defi Development Company"
                        />
                        <span>
                          It eliminates the need for intermediaries like banks,
                          offering transparent and accessible financial services
                          to a global audience.
                        </span>
                      </p>
                      <p>
                        <img
                          src={require("../../image/new/DEFI/arrow.png")}
                          alt="Defi Development Company"
                        />
                        <span>
                          Key components include smart contracts, lending
                          platforms, stablecoins, and innovative strategies like
                          yield farming.
                        </span>
                      </p>
                      <a href="/contact-us">
                        <button className="defi-button">Free Demo</button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="key-components-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-5">
                    <div className="key-components-content">
                      <h2>
                        <span>Key Components</span>
                        <br />
                        Of DeFi Development?
                      </h2>
                      <p>
                        Before getting into the project. You should know the key
                        components playing an important role in Defi
                        development. As a defi development company we make sure
                        these crucial factors are inside our  defi product.
                        Let's know all the key components .
                      </p>
                      <a href="https://join.skype.com/invite/wg5IW8g4Uaca">
                        <button className="defi-button">
                          Free Consultation
                        </button>
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-7 d-flex smart-key-cards">
                    <div className="col-lg-6">
                      <div className="smart-card">
                        <img
                          src={require("../../image/new/DEFI/contract-icon.webp")}
                          alt="Defi Dervelopment Company"
                        />
                        <h3>Smart Contracts</h3>
                        <p>
                          Smart contracts are self-executing contracts with the
                          terms of the  conditions to meet with. Through smart
                          contract Transaction is executed automatedly and
                          eliminates the need of third parties.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="smart-card platform-card">
                        <img
                          src={require("../../image/new/DEFI/borrowing-icon.webp")}
                          alt="Defi Dervelopment Company"
                        />
                        <h3>Lending and Borrowing Platforms</h3>
                        <p>
                          DeFi platforms enable users to lend their
                          cryptocurrencies and earn interest or borrow assets by
                          collateralizing their existing holdings.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="smart-card coins-card ">
                        <img
                          src={require("../../image/new/DEFI/stabel-coin.webp")}
                          alt="Defi Dervelopment Company"
                        />
                        <h3>Stable coins</h3>
                        <p>
                          Stablecoins are cryptocurrencies that are fixed to be
                          stable assets like fiat currencies or commodities.
                          They provide stability in volatile crypto markets and
                          facilitate hassle free transactions within the DeFi
                          ecosystem.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="smart-card mining">
                        <img
                          src={require("../../image/new/DEFI/BitcoinMining.webp")}
                          alt="Defi Dervelopment Company"
                        />
                        <h3>Yield Farming and Liquidity Mining</h3>
                        <p>
                          These are strategies used by DeFi participants to earn
                          rewards by providing liquidity to decentralised
                          platforms. Users can stake their assets in liquidity
                          pools and receive tokens in return.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="benefits-defi-section">
              <div className="container-fluid container-lg">
                <div className="row g-3">
                  <div className="col-lg-12">
                    <div className="benefit-title1">
                      <h3>
                        <span>Benefits of</span>
                        <br />
                        DeFi Development
                      </h3>
                      <p>
                        Before getting into the project. You should know the key
                        components playing an important role in Defi
                        development. As a defi development company we make sure
                        these crucial factors are inside our defi product. Let's
                        know all the key components .
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-6">
                    <div className="accessibility-card">
                      <img
                        src={require("../../image/new/DEFI/Accessibility-icon.webp")}
                        alt="Defi Development Company"
                      />
                      <h3>Accessibility</h3>
                      <p>
                        DeFi opens up fintech services to a global audience,
                        including those who are affected by traditional banking
                        systems.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6">
                    <div className="accessibility-card">
                      <img
                        src={require("../../image/new/DEFI/transparency-icon.webp")}
                        alt="Defi Development Company"
                      />
                      <h3>Transparency</h3>
                      <p>
                        Transactions on the blockchain are transparent and
                        immutable, providing a high level of trust and security.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6">
                    <div className="accessibility-card lower-cost">
                      <img
                        src={require("../../image/new/DEFI/lower-cost.png")}
                        alt="Defi Development Company"
                      />
                      <h3>Lower Cost</h3>
                      <p>
                        DeFi eliminates many intermediaries and reduces
                        transaction fees, making financial services more
                        affordable for users.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6">
                    <div className="accessibility-card innovation">
                      <img
                        src={require("../../image/new/DEFI/innovation-icon.webp")}
                        alt="Defi Development Company"
                      />
                      <h3>Innovation</h3>
                      <p>
                        DeFi is a centre of innovation, with developers
                        constantly creating new products and services to meet
                        the evolving needs of users.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6">
                    <div className="accessibility-card">
                      <img
                        src={require("../../image/new/DEFI/financial-icon.webp")}
                        alt="Defi Development Company"
                      />
                      <h3>Financial Inclusion</h3>
                      <p>
                        DeFi has the potential to bring financial services to
                        the unbanked and underbanked populations, empowering
                        them with greater control over their finances.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6">
                    <div className="accessibility-card">
                      <img
                        src={require("../../image/new/DEFI/security.webp")}
                        alt="Defi Development Company"
                      />
                      <h3>Security</h3>
                      <p>
                        Security is important in crypto world. Our Defi solution
                        comes with best in class security features developed to
                        restrict any kind of mallicious activity inside the
                        platform.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="defi-why-choose-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="benefit-title1">
                      <h3>
                        <span>Why Choose Beleaf</span> <br />
                        Your Defi Development Company?
                      </h3>
                      <p>
                        Our team comprises skilled developers, blockchain
                        engineers, and industry experts with a deep
                        understanding of DeFi technologies and trends. Five
                        reasons why you should beleaf technologies as your Defi
                        development company.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="defi-why-choose-banner">
                      <img
                        src={require("../../image/new/DEFI/defi-why-choose-banner.webp")}
                        alt="Defi Development Company"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 why-choose-defi">
                    <div className="defi-why-choose-content">
                      <p>
                        <img
                          src={require("../../image/new/DEFI/arrow.png")}
                          alt="Defi Development Company"
                        />
                        Expertise
                      </p>
                      <p>
                        <img
                          src={require("../../image/new/DEFI/arrow.png")}
                          alt="Defi Development Company"
                        />
                        Innovation
                      </p>

                      <p>
                        <img
                          src={require("../../image/new/DEFI/arrow.png")}
                          alt="Defi Development Company"
                        />
                        Security
                      </p>

                      <p>
                        <img
                          src={require("../../image/new/DEFI/arrow.png")}
                          alt="Defi Development Company"
                        />
                        Client-Centric Approach
                      </p>
                      <p>
                        <img
                          src={require("../../image/new/DEFI/arrow.png")}
                          alt="Defi Development Company"
                        />
                        On time delivery
                      </p>
                      <a href="https://wa.me/7904323274">
                        <button className="defi-button">Contact Us</button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* Ask Your Problem */}
            <section className="ask-your-problem-form-section defi-tell-us-your-problem-section">
              <div className="container">
                <div className="form-title">
                  <h3>Tell Us Your Problem</h3>
                  <h2>We will give you an innovative solution</h2>
                </div>
                <div className="form-details">
                  <div className="name-mail">
                    <div className="form-name">
                      <p>Name</p>
                      <input
                        type="text"
                        placeholder="Enter your full name"
                        className="form-control is-untouched is-pristine av-invalid form-control"
                        value={username}
                        minLength={3}
                        maxLength={25}
                        name="username"
                        onChange={handleNewFormChange}
                      ></input>
                      {usernameErr && usernameErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {validationErrors.username}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-mail">
                      <p>E-mail</p>
                      <input
                        type="email"
                        placeholder="Enter your email address"
                        className="form-control is-untouched is-pristine av-invalid form-control"
                        value={useremail}
                        name="useremail"
                        onChange={handleNewFormChange}
                      ></input>
                      {useremailErr && useremailErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {validationErrors.useremail}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="decribe-problem">
                    <div className="form-group decribe-your-problem">
                      <label htmlFor="comment">Problem</label>
                      <textarea
                        className="form-control"
                        rows="5"
                        minLength={5}
                        maxLength={250}
                        placeholder="Decribe your problem in 256 words."
                        name="usermessage"
                        value={usermessage}
                        onChange={handleNewFormChange}
                        id="comment"
                      ></textarea>
                      {usermessageErr && usermessageErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {validationErrors.usermessage}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="get-solution-btn">
                      <a
                        // href="/contact-us"
                        className="contact_bunt get-quote-btn live-demo"
                        onClick={() => sendQuestion()}
                      >
                        Get Solution
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="started-defi-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="started-content">
                      <h2>
                        <span>Get Started</span>
                        <br />
                        with DeFi Today
                      </h2>
                      <p>
                        {" "}
                        Ready to explore the possibilities of decentralised
                        finance? Contact us to schedule a consultation and
                        kickstart your DeFi development  journey with confidence
                        and expertise. Join the DeFi revolution with beleaf
                        technologies
                      </p>
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Contact Us"
                        className="defi-button"
                      >
                        Live Demo
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="started-banner">
                      <img
                        src={require("../../image/new/DEFI/get-started-banner.webp")}
                        alt="Defi Development Company"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </span>
        </main>
      </div>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Cex;
